import React, { forwardRef, memo } from 'react';
import { classNames } from '../../utils/classNames';
import { useAvatar } from '../../hooks';
import type { UserHeaderProps } from './UserHeader.types';

const UserHeaderComponent = forwardRef<HTMLDivElement, UserHeaderProps>(
  ({ uid, fullName, email, styleOverrides, className, ...restProps }, ref) => {
    const {
      imageUrl,
      initials,
      backgroundColor,
      hasImageError,
      handleImageError
    } = useAvatar({ fullName, uid });
    return (
      <div
        ref={ref}
        className={classNames('user-header', className)}
        style={styleOverrides}
        {...restProps}
      >
        {imageUrl && !hasImageError ? (
          <img
            src={imageUrl}
            alt={`${fullName}'s avatar`}
            className="user-header__avatar"
            onError={handleImageError}
          />
        ) : (
          <div
            className="user-header__avatar user-header__avatar--initials"
            style={{ backgroundColor }}
            title={`${fullName}'s avatar`}
          >
            {initials}
          </div>
        )}
        <h3 className="user-header__username">{fullName}</h3>
      </div>
    );
  }
);

UserHeaderComponent.displayName = 'UserHeader';

export const UserHeader = memo(UserHeaderComponent);
